// import React, { useState } from "react";
// import { Box, Typography, Paper, Grid } from "@mui/material";

// const MAX_VALUE = 15000;

// export interface ProductItem {
//   name: string;
//   value: number;
//   color?: string;
// }

// export const products: ProductItem[] = [
//   { name: "CBC", value: 12799, color: "#6A4DFF" },
//   { name: "LFT", value: 6000 },
//   { name: "Thyroid Profile", value: 8000 },
//   { name: "Radio Screening Package", value: 4000 },
//   { name: "Fever Package", value: 7000 },
//   { name: "Diabets Care Package", value: 12201 },
// ];

// const LabProductsCard: React.FC = () => {
//   const [selected, setSelected] = useState<string | null>(null);

//   return (
//     <Paper
//       sx={{
//         p: 2,
//         borderRadius: "16px",
//         border: "1px solid #E5E5E5",
//       }}
//     >
//       {/* Header */}
//       <Grid container justifyContent="space-between" mb={3}>
//         <Grid item>
//           <Typography variant="h6" sx={{ color: "#BAB8C8" }}>
//             Statistics
//           </Typography>
//           <Typography variant="h5" sx={{ fontWeight: 700 }}>
//             Top Test Packages
//           </Typography>
//         </Grid>

//         <Grid item textAlign="right">
//           <Typography variant="body1" sx={{ color: "#BAB8C8" }}>
//             This week
//           </Typography>
//           <Typography variant="h5" sx={{ fontWeight: 700 }}>
//             50,000
//           </Typography>
//         </Grid>
//       </Grid>

//       {/* Bars */}
//       {products.map((item) => {
//         const widthPercent = (item.value / MAX_VALUE) * 100;
//         const isSelected = selected === item.name;

//         return (
//           <Grid
//             key={item.name}
//             container
//             alignItems="center"
//             mb={3}
//             onClick={() => setSelected(item.name)}
//             sx={{ cursor: "pointer", position: "relative" }}
//           >
//             {/* Tooltip Bubble (Figma green tag) */}
//             {isSelected && (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: "-45px",
//                   left: `${widthPercent - 10}%`,
//                   transform: "translateX(-50%)",
//                   background: "#098963",
//                   color: "#fff",
//                   borderRadius: "12px",
//                   padding: "8px 16px",
//                   zIndex: 10,
//                   width: "160px",
//                   textAlign: "center",
//                   boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//                 }}
//               >
//                 <Typography fontWeight={700} fontSize={14}>
//                   {item.name}
//                 </Typography>
//                 <Typography fontSize={13}>
//                   {item.value.toLocaleString()}
//                 </Typography>
//               </Box>
//             )}

//             {/* Bar Background */}
//             <Grid item xs={10}>
//               <Box
//                 sx={{
//                   //   background: isSelected ? "#E7D9FF" : "#D3D3DD",
//                   background: isSelected ? "#6A4DFF" : "#A2A2B3",
//                   py: 1,
//                   px: 2,
//                   borderRadius: 2,
//                   position: "relative",
//                 }}
//               >
//                 {/* Fill bar */}
//                 <Box
//                   sx={{
//                     width: `${widthPercent}%`,
//                     background: isSelected ? "#6A4DFF" : "#A2A2B3",
//                     height: 16,
//                     borderRadius: 2,
//                     transition: "0.3s",
//                   }}
//                 ></Box>

//                 {/* Label */}
//                 <Typography
//                   sx={{
//                     position: "absolute",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#000",
//                     fontWeight: 600,
//                   }}
//                 >
//                   {item.name}
//                 </Typography>
//               </Box>
//             </Grid>

//             {/* Value Text */}
//             <Grid item xs={2} textAlign="right">
//               <Typography sx={{ fontWeight: 600 }}>
//                 {item.value.toLocaleString()}
//               </Typography>
//             </Grid>
//           </Grid>
//         );
//       })}

//       {/* X-Axis Labels */}
//       <Grid container justifyContent="space-between" mt={4}>
//         {["0", "2k", "5k", "10k", "15k"].map((l) => (
//           <Typography key={l} sx={{ color: "#888", fontWeight: 600 }}>
//             {l}
//           </Typography>
//         ))}
//       </Grid>
//     </Paper>
//   );
// };

// export default LabProductsCard;





import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue,LoacalVariables } from "../../../commonFunctions/CommonFunctions";

// ✅ REMOVED: No more static MAX_VALUE - dynamic calculation
export interface ProductItem {
  name: string;
  value: number;
  color?: string;
  testId?: string;
}

export const LabProductsCard: React.FC = () => {
  const [selected, setSelected] = useState<string | null>(null);
  const [products, setProducts] = useState<ProductItem[]>([]);
  const [labId, setLabId] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [totalBookings, setTotalBookings] = useState(0);

  // ✅ DYNAMIC: Calculate max value from real data
  const maxValue = products.length > 0 
    ? Math.max(...products.map(p => p.value)) * 1.1 // 10% padding
    : 100;

  // Get labId (UserId) from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 LabId (UserId):", userId);
    setLabId(userId || "");
  }, []);

  // Fetch most booked tests
  useEffect(() => {
    const fetchMostBookedTests = async () => {
      if (!labId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        console.log("📡 FETCHING MOST BOOKED TESTS FOR LAB:", labId);
        
        const response: any = await http.get(`lab/LabService/most-booked-tests/${labId}`);
        console.log("📦 API RESPONSE:", response);
        
        if (response?.status === true && response.data?.tests) {
          const data: ProductItem[] = response.data.tests.map((item: any) => ({
            name: item.testName || "Unknown Test",
            value: item.totalBookings || 0,
            testId: item.testId || "",
            color: "#6A4DFF"
          }));
          
          setProducts(data);
          setTotalBookings(response.data.totalBookings || 0);
        } else {
          setProducts([]);
          setTotalBookings(0);
        }
      } catch (error: any) {
        console.error("💥 API ERROR:", error);
        setProducts([]);
        setTotalBookings(0);
      } finally {
        setLoading(false);
      }
    };

    fetchMostBookedTests();
  }, [labId]);

  if (loading) {
    return (
      <Paper sx={{ p: 2, borderRadius: "16px", border: "1px solid #E5E5E5" }}>
        <Typography>Loading top tests...</Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "16px",
        border: "1px solid #E5E5E5",
      }}
    >
      {/* Header */}
      <Grid container justifyContent="space-between" mb={3}>
        <Grid item>
          <Typography variant="h6" sx={{ color: "#BAB8C8" }}>
            Statistics
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Top Test Packages
          </Typography>
        </Grid>

        <Grid item textAlign="right">
          <Typography variant="body1" sx={{ color: "#BAB8C8" }}>
            This week
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {totalBookings.toLocaleString()}
          </Typography>
        </Grid>
      </Grid>

      {/* Bars */}
      {products.map((item) => {
        // ✅ DYNAMIC: Calculate width based on real max value
        const widthPercent = maxValue > 0 ? Math.min((item.value / maxValue) * 100, 100) : 0;
        const isSelected = selected === item.name;

        return (
          <Grid
            key={item.testId || item.name}
            container
            alignItems="center"
            mb={3}
            onClick={() => setSelected(item.name)}
            sx={{ cursor: "pointer", position: "relative" }}
          >
            {/* Tooltip Bubble */}
            {isSelected && (
              <Box
                sx={{
                  position: "absolute",
                  top: "-45px",
                  left: `${widthPercent - 10}%`,
                  transform: "translateX(-50%)",
                  background: "#098963",
                  color: "#fff",
                  borderRadius: "12px",
                  padding: "8px 16px",
                  zIndex: 10,
                  width: "160px",
                  textAlign: "center",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                }}
              >
                <Typography fontWeight={700} fontSize={14}>
                  {item.name}
                </Typography>
                <Typography fontSize={13}>
                  {item.value.toLocaleString()}
                </Typography>
              </Box>
            )}

            {/* Bar Background */}
            <Grid item xs={10}>
              <Box
                sx={{
                  background: isSelected ? "#6A4DFF" : "#A2A2B3",
                  py: 1,
                  px: 2,
                  borderRadius: 2,
                  position: "relative",
                }}
              >
                {/* Fill bar */}
                <Box
                  sx={{
                    width: `${widthPercent}%`,
                    background: isSelected ? "#6A4DFF" : "#A2A2B3",
                    height: 16,
                    borderRadius: 2,
                    transition: "0.3s",
                  }}
                ></Box>

                {/* Label */}
                <Typography
                  sx={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "14px",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                  }}
                >
                  {item.name.length > 20 ? `${item.name.substring(0, 20)}...` : item.name}
                </Typography>
              </Box>
            </Grid>

            {/* Value Text */}
            <Grid item xs={2} textAlign="right">
              <Typography sx={{ fontWeight: 600 }}>
                {item.value.toLocaleString()}
              </Typography>
            </Grid>
          </Grid>
        );
      })}

      {/* Show empty state if no products */}
      {products.length === 0 && !loading && (
        <Box textAlign="center" py={4}>
          <Typography sx={{ color: "#BAB8C8" }}>
            No top booked tests found
          </Typography>
        </Box>
      )}

      {/* ✅ DYNAMIC X-Axis Labels */}
      <Grid container justifyContent="space-between" mt={4}>
        <Typography sx={{ color: "#888", fontWeight: 600 }}>0</Typography>
        <Typography sx={{ color: "#888", fontWeight: 600 }}>
          {Math.round(maxValue / 4).toLocaleString()}
        </Typography>
        <Typography sx={{ color: "#888", fontWeight: 600 }}>
          {Math.round(maxValue / 2).toLocaleString()}
        </Typography>
        <Typography sx={{ color: "#888", fontWeight: 600 }}>
          {Math.round((maxValue * 3) / 4).toLocaleString()}
        </Typography>
        <Typography sx={{ color: "#888", fontWeight: 600 }}>
          {Math.round(maxValue).toLocaleString()}
        </Typography>
      </Grid>
    </Paper>
  );
};

export default LabProductsCard;
